export default {
  mounted() {
    document.querySelector('html').classList.add('mobile-widget-configurator')
  },
  destroyed() {
    document.querySelector('html').classList.remove('mobile-widget-configurator')
  }
}
